import { Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

/**
 * Application route paths — single source of truth for navigation
 */
export enum AppRoute {
  Checkout = 'sokinpay/payment',
  CustomerPay = 'sokinpay/customerPay',
  Embedded = 'embedded',
  EmbeddedV2 = 'embedded-v2',
  Payment = 'sokinpay/wallet/payment',
  AcquiredResponse = 'sokinpay/aq',
  PaymentLinksLite = 'sokinpay/payment-links-lite',
  Demo = 'demo',
}

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/external-redirect/external-redirect.component').then(
        (m) => m.ExternalRedirectComponent
      ),
    data: { url: environment.baseRedirectUrl },
    pathMatch: 'full',
  },
  {
    path: `${AppRoute.Checkout}/:corporateId/:currencyCode`,
    loadComponent: () =>
      import('./views/wallet-payment/wallet-payment.component').then(
        (m) => m.WalletPaymentComponent
      ),
    pathMatch: 'full',
  },
  {
    path: `${AppRoute.Checkout}/:id`,
    loadComponent: () =>
      import('./views/checkout/checkout.component').then((m) => m.CheckoutComponent),
    pathMatch: 'full',
  },
  {
    path: `${AppRoute.CustomerPay}/:id/:orderId`,
    loadComponent: () =>
      import('./views/customer-pay/customer-pay.component').then((m) => m.CustomerPayComponent),
    pathMatch: 'full',
  },
  {
    path: `${AppRoute.CustomerPay}/:id`,
    loadComponent: () =>
      import('./views/customer-pay/customer-pay.component').then((m) => m.CustomerPayComponent),
    pathMatch: 'full',
  },
  {
    path: AppRoute.CustomerPay,
    loadComponent: () =>
      import('./views/customer-pay/customer-pay.component').then((m) => m.CustomerPayComponent),
    pathMatch: 'full',
  },
  {
    path: `${AppRoute.Embedded}/:id`,
    loadComponent: () =>
      import('./views/embedded/embedded.component').then((m) => m.EmbeddedComponent),
    pathMatch: 'full',
  },
  {
    path: `${AppRoute.EmbeddedV2}/:id`,
    loadComponent: () =>
      import('./views/checkout/components/embedded-payment/embedded-payment.component').then(
        (m) => m.EmbeddedPaymentComponent
      ),
    pathMatch: 'full',
  },
  {
    path: `${AppRoute.Payment}/:walletId`,
    loadComponent: () =>
      import('./views/wallet-payment/wallet-payment.component').then(
        (m) => m.WalletPaymentComponent
      ),
    pathMatch: 'full',
  },
  {
    path: `${AppRoute.AcquiredResponse}/:transactionId`,
    loadComponent: () =>
      import('./views/acquired-response/acquired-response.component').then(
        (m) => m.AcquiredResponseComponent
      ),
    pathMatch: 'full',
  },
  {
    path: `${AppRoute.PaymentLinksLite}/:id`,
    loadComponent: () =>
      import('./views/payment-links-lite/payment-links-lite.component').then(
        (m) => m.PaymentLinksLiteComponent
      ),
    pathMatch: 'full',
  },
];

if (!environment.production) {
  routes.push({
    path: AppRoute.Demo,
    loadComponent: () =>
      import('./views/example/example.component').then((m) => m.ExampleComponent),
    pathMatch: 'full',
  });
}
